import { createBrowserHistory } from 'history'

/**
 * This is here so we can easily unit test this
 */
export const createHistory = () => createBrowserHistory()

//  Keep a cached version of the history object here so the entire app shares the same history
const history = createHistory()

/**
 * Creates the history for the browser
 */
export default history
